const map = {
	"./ar.svg": 73551,
	"./cs.svg": 62116,
	"./de.svg": 80115,
	"./en.svg": 31215,
	"./fr.svg": 75506,
	"./iran.svg": 57514,
	"./it.svg": 10185,
	"./kh.svg": 28455,
	"./krt.svg": 71307,
	"./nl.svg": 18812,
	"./tr.svg": 28588,
	"./vi.svg": 79449
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57452;